/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Note_Changes_RevertedInputs */

const en_mobile_note_changes_reverted = /** @type {(inputs: Mobile_Note_Changes_RevertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your changes were reverted. Please try again.`)
};

const es_mobile_note_changes_reverted = /** @type {(inputs: Mobile_Note_Changes_RevertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus cambios fueron revertidos. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Your changes were reverted. Please try again." |
*
* @param {Mobile_Note_Changes_RevertedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_note_changes_reverted = /** @type {((inputs?: Mobile_Note_Changes_RevertedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Note_Changes_RevertedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_note_changes_reverted(inputs)
	return en_mobile_note_changes_reverted(inputs)
});